import { http_client } from '@/plugins/http_client';

const baseUrl = '/api/v1/mantenimiento-tipos-plaza';

const listar = (params = {}) => http_client(baseUrl, params, 'get');
const obtener = id => http_client(`${baseUrl}/${id}`, {}, 'get');
const crear = body => http_client(baseUrl, body, 'post');
const actualizar = (id, body) => http_client(`${baseUrl}/${id}`, body, 'put');
const eliminar = id => http_client(`${baseUrl}/${id}`, {}, 'delete');
const listarPlazas = (id, params = {}) => http_client(`${baseUrl}/${id}/plazas`, params, 'get');
const listarPlazasActivas = (params = {}) => http_client(`${baseUrl}/plazas-activas`, params, 'get');
const sincronizarPlazas = (id, body) => http_client(`${baseUrl}/${id}/plazas`, body, 'put');
const desvincularPlaza = (id, idPlaza) => http_client(`${baseUrl}/${id}/plazas/${idPlaza}`, {}, 'delete');
const sincronizarPlazasAscenso = (id, body) => http_client(`${baseUrl}/${id}/plazas-ascenso`, body, 'put');

export default {
  listar,
  obtener,
  crear,
  actualizar,
  eliminar,
  listarPlazas,
  listarPlazasActivas,
  sincronizarPlazas,
  desvincularPlaza,
  sincronizarPlazasAscenso,
};
